import { clamp as clampValue } from './math.utils';
import { Vector2 } from '@typings/vectors';

export function getCardinalVector(direction: 'UP' | 'DOWN' | 'LEFT' | 'RIGHT'): Vector2 {
  switch (direction) {
    case 'UP':
      return [0, -1] as Vector2;
    case 'DOWN':
      return [0, 1] as Vector2;
    case 'LEFT':
      return [-1, 0] as Vector2;
    case 'RIGHT':
      return [1, 0] as Vector2;
  }
}

export function isInside(position: Vector2, origin: Vector2, size: Vector2): boolean {
  const inside =
    position[0] >= origin[0] && position[0] <= origin[0] + size[0] && position[1] >= origin[1] && position[1] <= origin[1] + size[1];
  return inside;
}

export function add(a: Vector2, b: Vector2): Vector2 {
  return [a[0] + b[0], a[1] + b[1]] as Vector2;
}

export function subtract(a: Vector2, b: Vector2): Vector2 {
  return [a[0] - b[0], a[1] - b[1]] as Vector2;
}

export function multiply(a: Vector2, b: Vector2): Vector2 {
  return [a[0] * b[0], a[1] * b[1]] as Vector2;
}

export function divide(a: Vector2, b: Vector2): Vector2 {
  return [a[0] / b[0], a[1] / b[1]] as Vector2;
}

export function scale(a: Vector2, scalar: number): Vector2 {
  return [scalar * a[0], scalar * a[1]] as Vector2;
}

export function zero(): Vector2 {
  return [0, 0] as Vector2;
}

export function one(): Vector2 {
  return [1, 1] as Vector2;
}

export function half(): Vector2 {
  return [0.5, 0.5] as Vector2;
}

export function clamp(v: Vector2, min: Vector2, max: Vector2): Vector2 {
  return [clampValue(v[0], min[0], max[0]), clampValue(v[1], min[1], max[1])] as Vector2;
}

export function clamp01(v: Vector2): Vector2 {
  return clamp(v, zero(), one());
}

export function lerp(a: Vector2, b: Vector2, t: number): Vector2 {
  const delta = subtract(b, a);
  if (magnitudeSquared(delta) < 0.0001) return a;

  return add(a, scale(subtract(b, a), t));
}

export function magnitude(v: Vector2): number {
  return Math.sqrt(v[0] ** 2 + v[1] ** 2);
}

export function magnitudeSquared(v: Vector2): number {
  return v[0] ** 2 + v[1] ** 2;
}
